import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppIcBefehl23 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Form",
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".white{fill:#fff;}.black{fill:currentColor;}" }) }), /* @__PURE__ */ _jsxs("g", {
		id: "Command_23",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				className: "black",
				x: 21,
				y: 11,
				width: 22,
				height: 42,
				rx: 5,
				ry: 5
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "white",
				d: "M38,46c-.55,0-1-.45-1-1v-3.7l-11.83-17.75c-.11-.16-.17-.36-.17-.55v-4c0-.55.45-1,1-1s1,.45,1,1v3.7l11.83,17.75c.11.16.17.36.17.55v4c0,.55-.45,1-1,1Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "white",
				d: "M38,46c-.55,0-1-.45-1-1v-3.7l-11.83-17.75c-.11-.16-.17-.36-.17-.55v-4c0-.55.45-1,1-1s1,.45,1,1v3.7l11.83,17.75c.11.16.17.36.17.55v4c0,.55-.45,1-1,1Z"
			})
		]
	})]
});
export default SvgAppIcBefehl23;
